<button class="pull-right gdt-button" (click)="onClick()">
  @if (hasIcon) {
    <i class="fa fa-plus-circle fa-lg pr-3"></i>
    }{{ btnLabel }}
  </button>
